import { getCouponsReport } from "../../../Redux/Reports/ReportsActions";
import Loading from "../../../Components/Common/Loading/Loading";
import { ColDef, GridReadyEvent } from "ag-grid-community";
import exportToExcel from "../../../Util/exportToExcel";
import { AppDispatch } from "../../../Redux/store";
import React, { useEffect, useState } from "react";
import styles from "./CouponsReport.module.scss";
import { RootState } from "../../../Redux/store";
import { IoCloseSharp } from "react-icons/io5";
import { AgGridReact } from "ag-grid-react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import moment from "moment";

interface CouponsReportType {
  id: number;
  name: string;
  percent: number;
  maxDiscount: number;
  isActive: boolean;
  startDate: string;
  enddate: string;
  voucherType: number;
  createdBy: number;
  createdAt: string;
  modifiedBy: number | null;
  modifiedAt: string | null;
  voucherlimit: number;
  usedCount: number;
}

const defaultColDef: ColDef = {
  resizable: true,
  sortable: true,
  filter: false,
  wrapText: true,
  autoHeight: true,
  unSortIcon: true,
};

function CouponsReport() {
  const dispatch = useDispatch<AppDispatch>();
  const [search, setSearch] = useState("");
  const { couponsReport, couponsReportLoading } = useSelector(
    (state: RootState) => state.reports,
  );

  const [rowData, setRowData] = useState<CouponsReportType[]>([]);
  const [gridApi, setGridApi] = useState<any>(null);

  const applyFilters = (rowData: CouponsReportType[]) => {
    let array = [...rowData];

    if (search?.length > 3) {
      array = array.filter(
        (voucher: CouponsReportType) =>
          voucher?.name?.toLowerCase()?.includes(search?.toLowerCase()) ||
          voucher?.percent?.toString()?.includes(search?.toLowerCase()) ||
          voucher?.maxDiscount?.toString()?.includes(search?.toLowerCase()) ||
          voucher?.startDate?.toLowerCase()?.includes(search?.toLowerCase()) ||
          voucher?.enddate?.toLowerCase()?.includes(search?.toLowerCase()) ||
          voucher?.voucherType?.toString()?.includes(search?.toLowerCase()),
      );
    }

    return array;
  };

  const filteredRowData = applyFilters(rowData);

  const columnDefs: ColDef<CouponsReportType>[] = [
    {
      headerName: "Name",
      flex: 1,
      minWidth: 150,
      field: "name",
    },
    {
      headerName: "Percent",
      field: "percent",
      flex: 1,
      minWidth: 150,
    },

    {
      headerName: "Max Discount",
      field: "maxDiscount",
      flex: 1,
      minWidth: 100,
      valueGetter: (params) => {
        return `$ ${params?.data?.maxDiscount}`;
      },
    },

    {
      headerName: "Used Count",
      field: "usedCount",
      flex: 1,
      minWidth: 100,
    },

    {
      headerName: "Start Date",
      field: "startDate",
      flex: 1,
      minWidth: 150,
      valueGetter: (params) =>
        moment(params?.data?.startDate).format("MM/DD/YYYY hh:mm A"),
    },

    {
      headerName: "End Date",
      field: "enddate",
      flex: 1,
      minWidth: 150,
      valueGetter: (params) =>
        moment(params?.data?.enddate).format("MM/DD/YYYY hh:mm A"),
    },

    {
      headerName: "Voucher Type",
      field: "voucherType",
      flex: 1,
      minWidth: 100,
      valueGetter: (params) => {
        return params?.data?.voucherType === 1
          ? "Package"
          : params?.data?.voucherType === 2
            ? "Booking"
            : "N/A";
      },
    },
  ];

  const onGridReady = (params: GridReadyEvent) => {
    setGridApi(params?.api);
    params?.api?.sizeColumnsToFit();
  };

  useEffect(() => {
    if (!gridApi) return;

    const handleResize = () => {
      gridApi?.sizeColumnsToFit();
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [gridApi]);

  useEffect(() => {
    dispatch(getCouponsReport());

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (couponsReport) {
      setRowData(couponsReport);
    }
  }, [couponsReport]);

  if (couponsReportLoading) {
    return (
      <div className={styles.loadingContainer}>
        <div className={styles.loadingIcon}>
          <Loading />
        </div>
      </div>
    );
  }

  return (
    <React.Fragment>
      <div className={styles.mainContainer}>
        <div className={styles.topContainer}>
          <div className={styles.headingContainer}>
            <h1 className={styles.heading}>Coupons</h1>
          </div>
          <div className={styles.buttonContainer}>
            {filteredRowData?.length > 0 && (
              <button
                className={styles.button}
                onClick={() =>
                  exportToExcel({
                    data: filteredRowData || [],
                    fileName: "Coupons Report",
                  })
                }
              >
                Export
              </button>
            )}
          </div>
        </div>
        <div className={styles.bodyContainer}>
          <div className={styles.doubleInputContainer}>
            <div className={styles.searchContainer}>
              <div className={styles.searchContainerInner}>
                <input
                  type="text"
                  className={styles.input}
                  placeholder="Search"
                  value={search}
                  onChange={(e) => setSearch(e?.target?.value || "")}
                />
                <div
                  className={styles.iconContainer}
                  onClick={() => setSearch("")}
                >
                  <IoCloseSharp className={styles.icon} />
                </div>
              </div>
            </div>
          </div>
          <div className={styles.gridContainer}>
            <AgGridReact
              className={styles.grid}
              rowData={filteredRowData}
              columnDefs={columnDefs}
              defaultColDef={defaultColDef}
              onGridReady={onGridReady}
              pagination={true}
              paginationPageSize={10}
              paginationPageSizeSelector={[5, 10, 20, 50, 100]}
              animateRows={true}
              domLayout="autoHeight"
            />
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

export default CouponsReport;
